import {
    Injectable,
    Signal
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DatiqUserTiers } from '../../models/datiq-user.enums';
import {
    IDatiqUser,
    IDatiqUserModalInfo,
    IDatiqUserStoreService,
} from '../../models/datiq-user.interface';
import * as DatiqUserActions from '../datiq-user.actions';
import * as DatiqUserSelectors from '../datiq-user.selectors';

@Injectable({
    providedIn: 'root',
})
export class DatiqUserStoreService implements IDatiqUserStoreService {
    constructor(private _store: Store) {}

    logInUserSuccess(user: IDatiqUser): void {
        this._store.dispatch(DatiqUserActions.loginSuccess({ user }));
    }

    isLoggedInUserLoaded$(): Observable<boolean> {
        return this._store.select(DatiqUserSelectors.getSelectedLoaded);
    }

    isLoggedInUserLoggedIn$(): Observable<boolean> {
        return this._store.select(DatiqUserSelectors.getSelectedLoggedIn);
    }
    isLoggedInUserLoggedInSig(): Signal<boolean> {
        return this._store.selectSignal(DatiqUserSelectors.getSelectedLoggedIn);
    }

    getLoggedInUser$(): Observable<IDatiqUser> {
        return this._store.select(DatiqUserSelectors.getSelected);
    }

    hasPermissions$(permissionsList: string[]): Observable<boolean> {
        return this._store.select(
            DatiqUserSelectors.hasPermissions({ permissions: permissionsList }),
        );
    }

    hasCapabilities$(capabilities: string[]): Observable<boolean> {
        return this._store.select(
            DatiqUserSelectors.hasCapabilities(capabilities)
        );
    }

    hasCapabilities(capabilities: string[]): Signal<boolean> {
        return this._store.selectSignal(
            DatiqUserSelectors.hasCapabilities(capabilities)
        );
    }

    isLoggedInUserTier$(tier: DatiqUserTiers): Observable<boolean> {
        return this._store.select(DatiqUserSelectors.isLoggedInUserTier(tier));
    }

    getUserLoggedInTier$(): Observable<DatiqUserTiers> {
        return this._store.select(DatiqUserSelectors.getUserLoggedInTier());
    }

    logOut(): void {
        this._store.dispatch(DatiqUserActions.logout());
    }

    setModalShowAgain(modalId: string, state: boolean) {
        this._store.dispatch(DatiqUserActions.showAgain({ modalId, state }));
    }

    getModalState$(modalId: string): Observable<IDatiqUserModalInfo> {
        return this._store.select(DatiqUserSelectors.getModalState(modalId));
    }

    viewModal(modalId: string) {
        this._store.dispatch(DatiqUserActions.viewModal({ modalId }));
    }

    cacheUI(uiId: string, uiSettings: unknown) {
        this._store.dispatch(DatiqUserActions.cacheUI({ uiId, uiSettings }));
    }

    getUiCache$(id: string): Observable<unknown> {
        return this._store.select(DatiqUserSelectors.getUiCache({ id }));
    }

    refreshUserResources(): void {
        this._store.dispatch(DatiqUserActions.refreshUserResources());
    }
}
